import TimePills from './TimePills';

export default TimePills;